import type { ChatMessage } from '../types/chat'

import { utteranceHasMailOrEmailKeyword } from './inlineMailConfirm'

/** Top-level send / ask / tell / message delegation (not self-reminder). */
export function utteranceLooksLikeMessageDelegation(text: string): boolean {
  const raw = (text || '').trim()
  if (!raw) return false
  if (utteranceHasMailOrEmailKeyword(raw)) return false
  if (/\b(remind\s+me|rappelle[\s-]?moi|rappelez[\s-]?moi)\b/i.test(raw)) return false
  return (
    /^(?:please\s+)?send\s+(?:a\s+)?message\s+to\s+.+\s+to\s+.+/is.test(raw) ||
    /^(?:please\s+)?message\s+.+\s+to\s+.+/is.test(raw) ||
    /^(?:please\s+)?(?:can\s+you\s+|could\s+you\s+)?(?:(?:i\s+)?(?:need|want)\s+to\s+)?(?:ask|tell|have|get|let)\s+(?!me\b|myself\b|you\b).+\s+to\s+.+/is.test(
      raw,
    )
  )
}

export function isMessageDelegationFlowInProgress(messages: readonly ChatMessage[]): boolean {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.role !== 'assistant' || m.historySnapshot) continue
    if (
      m.uiType === 'recipient_type_options' ||
      m.uiType === 'delivery_channel_options' ||
      m.uiType === 'assignee_options' ||
      m.awaitingMessageConfirmation ||
      m.awaitingMessageEditField ||
      m.awaitingRecipientNameCorrection
    ) {
      return true
    }
    if (m.secretaryMessage && !m.secretaryMessage.message_sent_status) {
      const note = (m.secretaryMessage.autofill_note || '').trim()
      if (note && note !== 'message_sent') return true
    }
    return false
  }
  return false
}

/** Message intents need hosted ``/chat/command`` (cards, pending workflow), not Laravel ``sendMessage``. */
export function shouldUseHostedChatForMessage(
  text: string,
  messages: readonly ChatMessage[],
): boolean {
  return utteranceLooksLikeMessageDelegation(text) || isMessageDelegationFlowInProgress(messages)
}
